import { Box, Typography } from "@mui/material";

const SectionWrapper = ({ title, children }) => {
  return (
    <Box sx={{ mb: 6 }}>
      <Typography
        component="div"
        variant="h5"
        fontWeight={700}
        gutterBottom
        sx={{ marginBlock: "1rem" }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          "& p": {
            marginBottom: "1rem",
            lineHeight: 1.65,
          },

          "& > * + *": {
            marginTop: "1rem",
          },

          "& ul": {
            listStyle: "disc",
            paddingLeft: "1.25rem",
            marginTop: "0.5rem",
            marginBottom: "1.25rem",
          },

          "& ul li": {
            marginBottom: "0.6rem",
            lineHeight: 1.6,
          },

          "& ol": {
            listStyle: "none",
            counterReset: "item",
            paddingLeft: 0,
            marginBottom: "1.25rem",
            marginTop: "0.5rem",
          },

          "& ol li": {
            counterIncrement: "item",
            display: "grid",
            gridTemplateColumns: "3ch auto",
            columnGap: "0.5rem",
            marginBottom: "0.6rem",
            lineHeight: 1.6,
          },

          "& ol li::before": {
            content: "counter(item) '. '",
            fontWeight: 600,
            textAlign: "right",
          },

          "& ul ul": {
            listStyleType: "circle",
            paddingLeft: "1.25rem",
            marginTop: "0.25rem",
          },

          "& ol ol": {
            paddingLeft: "1.5rem",
            marginTop: "0.25rem",
          },

          "& strong": {
            fontWeight: 700,
          },

          "& strong, & p, & li": {
            "& a": {
              color: "primary.main",
              textDecoration: "none",
              cursor: "pointer",
              fontWeight: "inherit",
            },
            "& a:hover": {
              textDecoration: "underline",
            },
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default SectionWrapper;
